<template>
  <component :is="layoutTag" :class="embedded ? 'sp-settlement-payment-embedded' : ''">
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="结算ID" prop="settlementId">-->
<!--                <a-input-->
<!--                  v-model="queryParam.settlementId"-->
<!--                  placeholder="请输入结算ID"-->
<!--                  :disabled="embedded"-->
<!--                  :allow-clear="!embedded"-->
<!--                />-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.settlementPayment.search.money')" prop="money">
                  <a-input
                    v-model="queryParam.money"
                    :placeholder="$t('views.settlementPayment.search.moneyPlaceholder')"
                    allow-clear
                  />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.settlementPayment.search.sort')" prop="sort">
                  <a-input
                    v-model="queryParam.sort"
                    :placeholder="$t('views.settlementPayment.search.sortPlaceholder')"
                    allow-clear
                  />
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery">
                  <a-icon type="search" />{{ $t('views.settlementPayment.action.query') }}
                </a-button>
<!--                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>-->
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作（嵌入抽屉时不展示批量入口，保留列设置与刷新） -->
      <div class="table-operations">
        <template v-if="!embedded">
          <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:settlementPayment:add']">
            <a-icon type="plus" />{{ $t('views.settlementPayment.action.add') }}
          </a-button>
          <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['user:settlementPayment:edit']">
            <a-icon type="edit" />{{ $t('views.settlementPayment.action.edit') }}
          </a-button>
          <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:settlementPayment:remove']">
            <a-icon type="delete" />{{ $t('views.settlementPayment.action.delete') }}
          </a-button>
        </template>
<!--        <table-setting-->
<!--          :style="{float: 'right'}"-->
<!--          :table-size.sync="tableSize"-->
<!--          v-model="columns"-->
<!--          :refresh-loading="loading"-->
<!--          @refresh="getList" />-->
      </div>
      <!-- 嵌入抽屉内也需要审核：表单始终挂载，仅工具栏在 embedded 时隐藏 -->
      <create-form
        ref="createForm"
        :drawer-z-index="embedded ? 1100 : 1000"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="embedded ? undefined : { selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 'max-content' }"
      >
        <span slot="url" slot-scope="text, record">
          <template v-if="splitUrlList(record.url).length">
            <img
              v-for="(item, index) in splitUrlList(record.url)"
              :key="index"
              style="width: 48px;height: 48px;margin-right: 5px;margin-bottom: 5px"
              v-image-preview
              :src="item"
            />
          </template>
          <span v-else>{{ $t('views.settlementPayment.cell.dash') }}</span>
        </span>
        <span slot="auditStatus" slot-scope="text, record">
          {{ formatAuditStatus(record.auditStatus) }}
        </span>
        <span slot="sort" slot-scope="text, record">
          <a-input-number
            :value="record.sort"
            :min="0"
            style="width: 100px"
            @change="(value) => handleSortChange(record, value, 'sort')"
          />
        </span>
        <span slot="status" slot-scope="text, record">
          <a-switch
            :checked="record.status == 1 || record.status == '1'"
            @change="(checked) => handleStatusChange(record, checked)"
          />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">

          <template v-if="isAuditPending(record)">
            <a-divider type="vertical" v-hasPermi="['user:settlementPayment:edit']" />
            <a
              href="javascript:;"
              @click.stop="onAuditClick(record)"
              v-hasPermi="['user:settlementPayment:edit']"
            >
              <a-icon type="audit" />{{ $t('views.settlementPayment.action.audit') }}
            </a>
          </template>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :show-total="paginationShowTotal"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </component>
</template>

<script>
import { pageSettlementPayment,listSettlementPayment, delSettlementPayment, updateSettlementPayment } from '@/api/user/settlementPayment'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'SettlementPayment',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  props: {
    /** 嵌入抽屉等场景：不包 page-header-wrapper，并固定结算单查询 */
    embedded: {
      type: Boolean,
      default: false
    },
    /** 与 embedded 配合：结算单主键 ID，写入查询条件 */
    settlementId: {
      type: [Number, String],
      default: null
    }
  },
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        settlementId: null,
        type: null,
        money: null,
        url: null,
        auditStatus: null,
        auditReason: null,
        sort: null,
        status: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: []
    }
  },
  filters: {
  },
  created () {
    this.buildColumns()
    this.applyEmbeddedSettlementId()
    this.getList()
  },
  computed: {
    layoutTag () {
      return this.embedded ? 'div' : 'page-header-wrapper'
    }
  },
  watch: {
    '$i18n.locale' () {
      this.buildColumns()
    },
    settlementId () {
      if (!this.embedded) {
        return
      }
      this.applyEmbeddedSettlementId()
      this.handleQuery()
    }
  },
  methods: {
    paginationShowTotal (total) {
      return this.$t('views.settlementPayment.pagination.total', { total })
    },
    buildColumns () {
      const t = k => this.$t(k)
      this.columns = [
        { title: t('views.settlementPayment.column.id'), dataIndex: 'id', ellipsis: true, align: 'center' },
        { title: t('views.settlementPayment.column.money'), dataIndex: 'money', ellipsis: true, align: 'center' },
        {
          title: t('views.settlementPayment.column.url'),
          dataIndex: 'url',
          scopedSlots: { customRender: 'url' },
          align: 'center'
        },
        {
          title: t('views.settlementPayment.column.auditStatus'),
          dataIndex: 'auditStatus',
          scopedSlots: { customRender: 'auditStatus' },
          ellipsis: true,
          align: 'center'
        },
        { title: t('views.settlementPayment.column.auditReason'), dataIndex: 'auditReason', ellipsis: true, align: 'center' },
        { title: t('views.settlementPayment.column.auditReasonEn'), dataIndex: 'auditReasonEn', ellipsis: true, align: 'center' },
        // {
        //   title: t('views.settlementPayment.column.sort'),
        //   dataIndex: 'sort',
        //   scopedSlots: { customRender: 'sort' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: t('views.settlementPayment.column.status'),
        //   dataIndex: 'status',
        //   scopedSlots: { customRender: 'status' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: t('views.settlementPayment.column.createTime'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: t('views.settlementPayment.column.operation'),
          dataIndex: 'operation',
          width: 220,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    },
    splitUrlList (url) {
      if (url == null || url === '') {
        return []
      }
      return String(url)
        .split(',')
        .map(s => s.trim())
        .filter(Boolean)
    },
    formatAuditStatus (value) {
      if (value === null || value === undefined || value === '') {
        return this.$t('views.settlementPayment.cell.dash')
      }
      const n = Number(value)
      const keyByNum = {
        0: 'views.settlementPayment.auditStatus.pending',
        1: 'views.settlementPayment.auditStatus.approved',
        2: 'views.settlementPayment.auditStatus.rejected'
      }
      const key = keyByNum[n]
      return key ? this.$t(key) : String(value)
    },
    isAuditPending (record) {
      const v = record && record.auditStatus
      return v === 0 || v === '0'
    },
    onAuditClick (record) {
      const form = this.$refs.createForm
      if (form && typeof form.handleAudit === 'function') {
        form.handleAudit(record)
      }
    },
    onEditRowClick (record) {
      const form = this.$refs.createForm
      if (form && typeof form.handleUpdate === 'function') {
        form.handleUpdate(record, undefined)
      }
    },
    applyEmbeddedSettlementId () {
      if (this.embedded && this.settlementId != null && this.settlementId !== '') {
        this.queryParam.settlementId = this.settlementId
      }
    },
    /** 查询结算付款列表 */
    getList () {
      this.loading = true
      pageSettlementPayment(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      const sid = this.embedded && this.settlementId != null && this.settlementId !== '' ? this.settlementId : undefined
      this.queryParam = {
        settlementId: sid,
        type: undefined,
        money: undefined,
        url: undefined,
        auditStatus: undefined,
        auditReason: undefined,
        sort: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      const idText = Array.isArray(ids) ? ids.join(', ') : String(ids)
      this.$confirm({
        title: this.$t('views.settlementPayment.confirm.deleteTitle'),
        content: this.$t('views.settlementPayment.confirm.deleteContent', { ids: idText }),
        onOk () {
          const data = that.ids.map(id => ({ id }))
          return delSettlementPayment(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(that.$t('views.settlementPayment.msg.deleteOk'), 3)
            })
        },
        onCancel () {
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('views.settlementPayment.confirm.exportTitle'),
        content: this.$t('views.settlementPayment.confirm.exportContent'),
        onOk () {
          const time = new Date().getTime()
          that.download('user/settlement-payment/export', {
            ...that.queryParam
          }, that.$t('views.settlementPayment.export.filename', { time }))
        },
        onCancel () {}
      })
    },
    /** 状态开关变更 */
    handleStatusChange (record, checked) {
      const statusValue = checked ? 1 : 0
      const updateData = {
        id: record.id,
        status: statusValue
      }
      updateSettlementPayment(updateData).then(() => {
        record.status = statusValue
        this.$message.success(this.$t('views.settlementPayment.msg.statusUpdateOk'))
        this.getList()
      }).catch(() => {
        this.$message.error(this.$t('views.settlementPayment.msg.statusUpdateFail'))
      })
    },
    /** 排序值变更 */
    handleSortChange (record, value, fieldName) {
      if (value === null || value === undefined) {
        return
      }
      const updateData = {
        id: record.id
      }
      updateData[fieldName] = value
      updateSettlementPayment(updateData).then(() => {
        record[fieldName] = value
        this.$message.success(this.$t('views.settlementPayment.msg.sortUpdateOk'))
        this.getList()
      }).catch(() => {
        this.$message.error(this.$t('views.settlementPayment.msg.sortUpdateFail'))
      })
    }
  }
}
</script>

<style scoped>
.sp-settlement-payment-embedded >>> .ant-card-body {
  padding-top: 8px;
}
.sp-embed-op-placeholder {
  color: rgba(0, 0, 0, 0.25);
}
</style>
